import { TutorialConfig } from "../types/tutorial";

const tariffsTutorial: TutorialConfig = {
  pageId: "tariffs",
  pageTitle: "Tariffs",
  steps: [
    {
      id: "tariffs-intro",
      title: "Tariff Intelligence",
      description:
        "Estimate landed costs and manage HTS classification requests in one place.",
      targetSelector: '[data-tutorial-step="tariffs-header"]',
      position: "bottom",
    },
    {
      id: "tariffs-tabs",
      title: "Calculator & Requests",
      description:
        "Switch between the Tariff Calculator and HTS Code Request tabs to run estimates or track classification requests.",
      targetSelector: '[data-tutorial-step="tariffs-tabs"]',
      position: "bottom",
    },
    {
      id: "tariffs-calculator",
      title: "Cost Calculator",
      description:
        "Enter product details, origin country, HTS code, and shipment value, then click Calculate Tariff to see duties, fees, and total landed cost.",
      targetSelector: '[data-tutorial-step="tariffs-calculator"]',
      position: "bottom",
      example: {
        productName: "Alloy Pig Iron Furnace Charge Blocks",
        htsCode: "7201.50.30.00",
        coo: "China",
        supplierName: "Cascade Services S.A.",
        quantity: "500",
        value: "237245",
      },
    },
    {
      id: "tariffs-results",
      title: "Cost Breakdown",
      description:
        "The results panel shows the base duty, additional tariffs, total duty amount, effective duty rate, and final landed cost for your shipment.",
      targetSelector: '[data-tutorial-step="tariffs-results"]',
      position: "left",
    },
    {
      id: "tariffs-save",
      title: "Save Calculation",
      description:
        "Click Save Calculation to store this estimate. Use the View History button at the top to see all saved calculations later.",
      targetSelector: '[data-tutorial-step="tariffs-save"]',
      position: "top",
    },
    {
      id: "tariffs-history",
      title: "View History",
      description:
        "Click View History to see all saved tariff calculations and revisit past estimates.",
      targetSelector: '[data-tutorial-step="tariffs-history"]',
      position: "bottom",
    },
    {
      id: "tariffs-assistant",
      title: "WorldLink Assistant",
      description:
        "Open the WorldLink Assistant to ask natural-language questions about tariffs and trade. A sample question is already filled in — just press Send.",
      targetSelector: '[data-tutorial-step="tariffs-assistant"]',
      position: "left",
    },
  ],
};

export default tariffsTutorial;
